import devices from '../../assets/deviceIcons';
import './DeviceIcon.scss';

const DeviceIcon = ({ countryIso, className = '', size = 'md' }) => (
  <img
    className={`device-icon ${className}`}
    src={devices[countryIso] ?? devices.LAPTOP}
    alt={countryIso}
    data-size={size}
  />
);

export default DeviceIcon;
